'use client';
import React, { useCallback, useEffect } from 'react';
import { Button, Center, Divider, Flex, Link, Text } from '@chakra-ui/react';
import { Navbar } from '@/src/app/_components/navigation/navbar/Navbar';
import { SLACK_URL } from '@/src/app/constants';
import { useRouter } from 'next/navigation';

export default function DockerPage() {
  const router = useRouter();
  useEffect(() => {
    router.push(`https://open.docker.com/extensions/marketplace?extensionId=livecycle/docker-extension`);
  }, [router]);
  const openDocker = useCallback(() => {
    router.push(
      `https://open.docker.com/extensions/marketplace?rnd=${Math.random().toString(
        2
      )}&extensionId=livecycle/docker-extension`
    );
  }, [router]);
  return (
    <Flex h={'full'} w={'full'} flexDirection={'column'}>
      <Flex w={'full'} borderBottom={'1px solid'} borderColor={'lc.system.neutral.30'}>
        <Navbar />
      </Flex>
      <Flex h={'full'} w={'full'} justifyContent={'center'}>
        <Center h={'full'} flexDirection={'column'} maxW={'680px'} gap={10}>
          <Text textStyle={'headline-sm'} textAlign={'center'}>
            Click open docker on the dialog shown by your browser if you don’t see a dialog, click launch Docker below
          </Text>
          <Link variant={'mixed'} href={SLACK_URL}>
            <Text textStyle={'body-lg'}>Join our community in the Slack family.</Text>
          </Link>
          <Button h={12} w={'max-content'} onClick={openDocker}>
            Launch Livecycle on Docker
          </Button>

          <Divider />
          <Center gap={1}>
            <Text textStyle={'body-lg'}>Don’t have Docker for desktop? </Text>
            <Link textStyle={'body-lg'} variant={'mixed'} href={'https://www.docker.com/products/docker-desktop/'}>
              Download now
            </Link>
          </Center>
          <Center gap={1} flexDirection={'column'}>
            <Text textStyle={'body-lg'}>©2023 Livecycle All rights reserved.</Text>
            <Flex gap={3}>
              <Link
                textStyle={'body-lg'}
                colorScheme={'secondary'}
                variant={'mixed'}
                href={'https://livecycle.io/terms-of-use/'}
              >
                Terms of use
              </Link>
              <Divider orientation={'vertical'} />
              <Link
                textStyle={'body-lg'}
                colorScheme={'secondary'}
                variant={'mixed'}
                href={'https://livecycle.io/privacy-policy/'}
              >
                Privacy policy
              </Link>
            </Flex>
          </Center>
        </Center>
      </Flex>
    </Flex>
  );
}
